import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from '../../../services/general.service';
import {Injectable} from '@angular/core';
import {Page} from '../../../model/page';

@Injectable()
export class PartsUsageService extends GeneralService {

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    getById(id: number): Observable<any> {

        if (id === 0) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/order-entry-system/parts-usage/view?id=${id}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    save(model: any, isCreate: boolean): Observable<any> {
        return this.http.get('')
            .catch(this.handleError);
    }

    public export(page: Page): Observable<any> {
        const url = '/master-data/part-usage-export';
        let params = new HttpParams();
        params = this.applyFilters(page, params);
        return this.http.get(url, {params: params});
    }

    public getDataList(page: Page): Observable<any> {
        const url = '/master-data/part-usage';
        return this.getRestList(page, url);
    }

    public initialize() {
        return {};
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/parts-usage.service.ts